export abstract class DOMRouteHandler {
  static async initAsync(): Promise<void> {
    return;
  }

  static init(): void {
    // to be overridden in sub classes
  }

  static finalize(): void {
    // to be overridden in sub classes
  }
}
